import { ConfigurationType, LevelType } from 'data/types';
import { getNextConfigurationName } from 'utils/configuration-generation';
import { collectPtacRooms } from 'utils/ptac-configuration';

export const PTAC_GENERATED_CONFIG_NAME = 'Generated PTAC Design';
export const PTAC_GENERATE_NO_ROOMS_REASON =
  'Add rooms on Layout & Sizing before generating a PTAC design';

export function nextPtacGeneratedConfigurationName(
  configurations: ConfigurationType[]
): string {
  return getNextConfigurationName(PTAC_GENERATED_CONFIG_NAME, configurations);
}

export function ptacGenerateDisabledReason(
  structure: LevelType[]
): string | undefined {
  return collectPtacRooms(structure).length === 0
    ? PTAC_GENERATE_NO_ROOMS_REASON
    : undefined;
}
